import { Controller } from "stimulus";
var onmount = require("onmount");

export default class extends Controller {
  static values = {
    url: String,
    date: String,
  };

  static targets = ["allTab", "tabPane", "dateLabel", "todayButton", "content", "dropdownButton", "dropdownSlot", "dropdown"];

  connect() {
    this.moveDropdownToSlot();
    this.showAll();
    this.updateTodayVisibility();
  }

  moveDropdownToSlot() {
    if (this.hasDropdownTarget && this.hasDropdownSlotTarget && !this.dropdownSlotTarget.contains(this.dropdownTarget)) {
      this.dropdownSlotTarget.innerHTML = '';
      this.dropdownSlotTarget.appendChild(this.dropdownTarget);
    }
  }

  showAll(event) {
    if (event) event.preventDefault();

    // Deactivate all dropdown items, activate "All"
    $(this.element).find('.dropdown-item').removeClass('active');
    if (this.hasAllTabTarget) {
      this.allTabTarget.classList.add('active');
    }

    // Update dropdown button text
    if (this.hasDropdownButtonTarget && this.hasAllTabTarget) {
      this.dropdownButtonTarget.textContent = this.allTabTarget.textContent;
    }

    // Close the dropdown
    $(this.element).find('.dropdown-toggle').dropdown('hide');

    // Show all tab panes and their subtitles
    this.tabPaneTargets.forEach(function(pane) {
      pane.classList.add('show', 'active');
      $(pane).find('.js-tab-subtitle').removeClass('d-none');
    });
  }

  showOne(event) {
    event.preventDefault();

    var targetId = event.currentTarget.getAttribute('data-target');

    // Deactivate all dropdown items, activate the clicked one
    $(this.element).find('.dropdown-item').removeClass('active');
    event.currentTarget.classList.add('active');

    // Update dropdown button text
    if (this.hasDropdownButtonTarget) {
      this.dropdownButtonTarget.textContent = event.currentTarget.textContent;
    }

    // Close the dropdown
    $(this.element).find('.dropdown-toggle').dropdown('hide');

    // Hide all panes and subtitles, then show the selected one
    this.tabPaneTargets.forEach(function(pane) {
      pane.classList.remove('show', 'active');
      $(pane).find('.js-tab-subtitle').addClass('d-none');
    });

    var targetPane = document.querySelector(targetId);
    if (targetPane) {
      targetPane.classList.add('show', 'active');
    }
  }

  previous() {
    this.dateValue = this.offsetDate(-1);
    this.loadContent();
  }

  next() {
    this.dateValue = this.offsetDate(1);
    this.loadContent();
  }

  gotoToday() {
    this.dateValue = this.localToday();
    this.loadContent();
  }

  pickDate() {
    var controller = this;

    if (this.flatpickrInstance) {
      this.flatpickrInstance.open();
      return;
    }

    this.flatpickrInstance = flatpickr(this.dateLabelTarget, {
      disableMobile: "true",
      defaultDate: this.dateValue,
      onChange: function (selectedDates) {
        if (selectedDates.length === 1) {
          controller.dateValue = selectedDates[0].toISOString().split("T")[0];
          controller.loadContent();
        }
      },
    });

    this.flatpickrInstance.open();
  }

  loadContent() {
    var controller = this;
    var url = this.urlValue;

    if (url.indexOf("?") !== -1) {
      url = url + "&date=" + this.dateValue;
    } else {
      url = url + "?date=" + this.dateValue;
    }

    this.contentTarget.innerHTML =
      '<div class="text-center"><div class="spinner spinner-border spinner-border-sm text-primary mx-auto my-4"></div></div>';

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (html) {
        controller.contentTarget.innerHTML = html;
        controller.moveDropdownToSlot();
        controller.showAll();
        controller.updateDateLabel();
        controller.updateTodayVisibility();
        controller.syncFlatpickr();
        $('[data-toggle="tooltip"]').tooltip({ sanitize: false });
        onmount();
      },
      error: function () {
        window.notyf.error(
          "Something went wrong when loading your request. Please try again."
        );
      },
    });
  }

  updateDateLabel() {
    var date = new Date(this.dateValue + "T00:00:00");
    var options = { weekday: "short", month: "short", day: "numeric" };
    var formatted = date.toLocaleDateString("en-US", options);
    this.dateLabelTarget.childNodes[0].textContent = formatted;
  }

  updateTodayVisibility() {
    var today = this.localToday();
    var isToday = this.dateValue === today;

    if (this.hasTodayButtonTarget) {
      if (isToday) {
        $(this.todayButtonTarget).addClass("d-none");
      } else {
        $(this.todayButtonTarget).removeClass("d-none");
      }
    }
  }

  syncFlatpickr() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.setDate(this.dateValue, false);
    }
  }

  offsetDate(days) {
    var date = new Date(this.dateValue + "T00:00:00");
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
  }

  localToday() {
    var now = new Date();
    return now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");
  }

  disconnect() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
      this.flatpickrInstance = null;
    }
  }
}
